import { Grid, Stack } from "@mui/material";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import {
  EncounterText,
  EncounterGrid,
  EncounterTimerContainer,
  EncounterTitleText,
  EncounterTextField
} from "../EncounterTimer/EnounterTimer.styles";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../context/Provider";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import { AddEncounterEvent } from "helpers/variables";
import { NotesObject } from "context/initialState/Notes";
import Session from "helpers/session";
import API from "api";
import { useNavigate } from "react-router-dom";

export let hideNote = "none";
export default function EncounterTimer() {
  const theme = useTheme();
  const { member, memberDispatch, encounters, encounterDispatch } =
    useContext(GlobalContext);
  const [pause, setPause] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(member?.secondsCounter || 0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [eventBody] = useState({
    coordinatorId: Session ? Session.crackCookieUserId("coordinator") : "",
    coordinatorName: Session ? Session.crackCookieUsername("coordinator") : "",
    memberId: member?.current ? member?.current.id : "",
    memberName: member?.current ? member?.current.username : "",
    duration: member ? member?.secondsCounter.toString() : "",
    escalatedDuration: 1,
    actions: encounters?.current ? encounters?.current : []
  });

  const HandlePauseResume = () => {
    setPause(!pause);
  };

  const HandleNoteOpen = () => {
    memberDispatch({
      type: "UPDATE_ENCOUNTER_NOTE_OPEN",
      payload: !member?.noteOpen
    });
  };

  const HandleNoteSubmit = () => {
    const noteBody: NotesObject = {
      memberId: member?.current.id || "",
      authorId: Session.crackCookieUserId("coordinator"),
      authorName: Session.crackCookieUsername("coordinator"),
      content: member?.notesContent || "",
      type: "staff"
    };

    API.kore.notes
      .create(noteBody, Session.crackCookieToken("coordinator"))
      .then((issued) => {
        console.log(issued);
      })
      .catch((err) => console.log(err));
    const encounterEvent = AddEncounterEvent("note", "Added Staff Note");
    Session.updateSessionEncounter(
      window.sessionStorage.getItem("encounter") ||
        Session.encrypt(JSON.stringify(eventBody)),
      encounterEvent,
      member?.secondsCounter.toString() || ""
    );
    memberDispatch({ type: "UPDATE_ENCOUNTER_CONTENT", payload: "" });
    memberDispatch({
      type: "UPDATE_ENCOUNTER_NOTE_OPEN",
      payload: !member?.noteOpen
    });
  };

  const handleEncounterSave = () => {
    if (
      JSON.parse(
        Session.decrypt(window.sessionStorage.getItem("encounter") || "")
      ) &&
      JSON.parse(
        Session.decrypt(window.sessionStorage.getItem("encounter") || "")
      ).actions.length !== 0
    ) {
      API.kore.encounters
        .add(
          Session.crackCookieToken("coordinator"),
          JSON.parse(
            Session.decrypt(window.sessionStorage.getItem("encounter") || "")
          )
        )
        .then((encounter) => {
          window.sessionStorage.removeItem("encounter");
        });
    }
  };

  const onPageLeave = (e: any) => {
    if (
      JSON.parse(
        Session.decrypt(window.sessionStorage.getItem("encounter") || "")
      ) &&
      JSON.parse(
        Session.decrypt(window.sessionStorage.getItem("encounter") || "")
      ).actions.length !== 0
    ) {
      e.preventDefault();
      e.returnValue = handleEncounterSave();
    }

    memberDispatch({ type: "UPDATE_SECONDS", payload: seconds + 1 });
  };

  useEffect(() => {
    if (window.sessionStorage.getItem("encounter")) {
      window.addEventListener("beforeunload", onPageLeave);
    } else {
      window.sessionStorage.setItem(
        "encounter",
        Session.encrypt(JSON.stringify(eventBody))
      );
      window.addEventListener("beforeunload", onPageLeave);
    }
    return () => {
      window.removeEventListener("beforeunload", onPageLeave);
    };
  }, []);

  useEffect(() => {
    !pause &&
      setTimeout(() => {
        setSeconds(seconds + 1);
      }, 1000);
  }, [seconds, pause]);

  return (
    <Grid container>
      <Grid item xs={0} sm={0} md={1.5} lg={0.7} />
      <Grid item xs={12} sm={12} md={9.8} lg={10.8}>
        <EncounterTimerContainer>
          <EncounterGrid container>
            <Grid item xs={3} md={3} lg={4}>
              <EncounterTitleText>
                {t("u-current-encounter")}
              </EncounterTitleText>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <EncounterText>
                {t("u-starts-at")}{" "}
                {moment(member?.encounterStart).format("HH:mm") || "00:00"}
              </EncounterText>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <EncounterText>
                {t("u-time")} {Math.floor(seconds / 60)}:
                {(seconds - Math.floor(seconds / 60) * 60).toLocaleString(
                  "en-US",
                  { minimumIntegerDigits: 2 }
                )}
              </EncounterText>
            </Grid>
            <Grid item xs={5} md={5} lg={4}>
              <Stack spacing={0.5} direction="row">
                <Button
                  variant="warning"
                  height={theme.spacing(6)}
                  onClick={HandlePauseResume}
                >
                  {pause ? t("u-resume") : t("u-pause")}
                </Button>
                <Button
                  variant="primary"
                  height={theme.spacing(6)}
                  width="33%"
                  onClick={HandleNoteOpen}
                >
                  {member?.noteOpen === false ? t("u-open-note") : "Close Note"}
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={0} md={0} lg={0} />
          </EncounterGrid>
          <Stack
            sx={{
              display: `${member?.noteOpen ? "block" : "none"}`
            }}
          >
            <EncounterTextField
              defaultValue={member?.notesContent}
              onBlur={(e) => {
                memberDispatch({
                  type: "UPDATE_ENCOUNTER_CONTENT",
                  payload: e.target.value
                });
              }}
              placeholder="Enter note"
              fullWidth
              multiline
              maxRows={2}
              minRows={2}
            />
            <Button
              variant="success"
              height={theme.spacing(6)}
              width={theme.spacing(30)}
              onClick={HandleNoteSubmit}
            >
              Submit
            </Button>
            <Grid container>
              <Grid item xs={6} />
              <Grid item xs={2}></Grid>
              <Grid item xs={4} />
            </Grid>
          </Stack>
        </EncounterTimerContainer>
      </Grid>
      <Grid item xs={0} sm={0} md={0.7} lg={0.5} />
    </Grid>
  );
}
